var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgReload = function SvgReload(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77,309a1,1,0,0,1-1-1,7.991,7.991,0,0,1,12.657-6.5v-.575a1,1,0,0,1,2,0v2.828a1,1,0,0,1-1,1H86.829a1,1,0,0,1,0-2h.086A6,6,0,0,0,78,308,1,1,0,0,1,77,309Zm14-2a1,1,0,0,0-1,1,6,6,0,0,1-8.915,5.243h.086a1,1,0,0,0,0-2H78.343a1,1,0,0,0-1,1v2.828a1,1,0,0,0,2,0V314.5A7.994,7.994,0,0,0,92,308,1,1,0,0,0,91,307Z",
    transform: "translate(-72 -296)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReload, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reload.94843168.svg";
export { ForwardRef as ReactComponent };